import { useQuery } from "@tanstack/react-query";
import { getAuthData } from "apis/access/get_auth_api";
import { authKeys } from "apis/access/query_keys_access";
import { simpleAlert } from "components/CommonLib/CommonLib";
import { useDispatch } from "react-redux";

// [GET] 권한 정보 가져오기
export const useGetAuthData = () => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: authKeys.authData(),
    queryFn: () => getAuthData(),
    enabled: true,
    retry: false,
    cacheTime: 0,

    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};
